import { Link } from "react-router-dom";
import { Button, Nav, Navbar, NavbarBrand, NavItem, NavLink } from "reactstrap";
import BonusPoints from "../../../components/bonifiedInteractions/BonusPoints";
import keycloak from "../../../keycloak";
import { isLoggedIn } from "../../../store/actions/LoginActions";
import { UrlPathBonifiedInteractions, UrlPathMain } from "../../../url";
import { SelectTheme } from "../../SwitchTheme";
import logoutIcon from "../images/Konto.svg";
import logo from "../images/marcopoloLogo.svg";

export const Header = () => {
  const handleLogout = () => {
    keycloak.logout();
  };
  return (
    <header>
      <Navbar expand="xs" style={{ paddingTop: 5, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <NavbarBrand
          tag={isLoggedIn() ? Link : undefined}
          to={isLoggedIn() ? UrlPathMain : undefined}
          style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}
        >
          <img
            src={logo}
            alt="MARC O’POLO"
            width="368"
            height="30"
            style={{
              height: 63,
              paddingLeft: isLoggedIn() ? 200 : 150,
            }}
          />
        </NavbarBrand>
        <Nav className="ml-auto" navbar>
          {isLoggedIn() && (
            <>
              <NavItem>
                <NavLink tag={Link} to={UrlPathBonifiedInteractions} style={{ textAlign: "center" }}>
                  <div
                    style={{
                      marginTop: "6px",
                      marginBottom: "-2px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span style={{ fontSize: 14, fontWeight: "bold" }}>Ihr Punktestand:</span>
                    <b>
                      <BonusPoints />
                    </b>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <Button color="link" onClick={handleLogout}>
                  <img src={logoutIcon} style={{ width: 24 }} alt="Logout" />
                  <br />
                  <span style={{ fontSize: 10 }}>Logout</span>
                </Button>
              </NavItem>
            </>
          )}
          <NavItem>
            <div style={{ paddingTop: 16 }}>
              <SelectTheme />
            </div>
          </NavItem>
        </Nav>
      </Navbar>
    </header>
  );
};
